const { useAtom } = require("jotai");
const { atomWithStorage } = require("jotai/utils");

export const AuthAtom = atomWithStorage("crytoappfrank_auth", {
  email: "",
  accessToken: "",
  id: null,
});

export const useAuthAtom = () => useAtom(AuthAtom);
